import { getQaSelector } from '../../../utils/common'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import { Status } from '../../Status'
import Text from '../../Text'
import { BirdviewEntityTitle } from '../BirdviewEntityTitle'
import { BirdviewRowActionButton } from '../BirdviewRowActionButton'

import {
  checkHasDashboardListRowStatusDot,
  checkHasDashboardListRowSubtitleContent,
  checkHasDashboardListRowSubtitleLine,
} from './DashboardListRow.utils'

import * as styles from './DashboardListRow.module.css'

function DashboardListRow({
  Before = null,
  Icon = null,
  Meta = null,
  Subtitle = null,
  Tags = null,
  actionKey,
  beforeProps,
  isActionPending,
  isUnread,
  metaProps,
  number,
  qaName,
  statusProps,
  subtitle,
  subtitleProps,
  tagsProps,
  title,
  onAction,
  onMouseDownTitle,
  onOpen,
}) {
  const hasSubtitleContent = checkHasDashboardListRowSubtitleContent({
    Subtitle,
    subtitleProps,
  })

  return (
    <div {...getQaSelector({ value: qaName })} className={styles.row}>
      {Before ? (
        <div className={styles.before}>
          <Before {...beforeProps} />
        </div>
      ) : null}
      {Icon ? (
        <Avatar
          Icon={Icon}
          className={styles.leading}
          size={AVATAR_HEIGHT_24}
        />
      ) : null}
      <div className={styles.main}>
        <BirdviewEntityTitle
          className={styles.title}
          isUnread={isUnread}
          number={number}
          title={title}
          onMouseDown={onMouseDownTitle}
          onOpen={onOpen}
        />
        {checkHasDashboardListRowSubtitleLine({
          hasSubtitleContent,
          statusProps,
          subtitle,
        }) ? (
          <div className={styles.subtitleLine}>
            {statusProps ? (
              <Status {...statusProps} className={styles.status} />
            ) : null}
            {checkHasDashboardListRowStatusDot({
              hasSubtitleContent,
              statusProps,
              subtitle,
            }) ? (
              <Text isSecondary className={styles.dot}>
                ·
              </Text>
            ) : null}
            {hasSubtitleContent ? <Subtitle {...subtitleProps} /> : null}
            {subtitle ? (
              <Text isSecondary className={styles.subtitle}>
                {subtitle}
              </Text>
            ) : null}
          </div>
        ) : null}
        {Tags ? (
          <div className={styles.tags}>
            <Tags {...tagsProps} />
          </div>
        ) : null}
      </div>
      {Meta || onAction ? (
        <div className={styles.trailing}>
          {Meta ? <Meta {...metaProps} /> : null}
          {onAction ? (
            <BirdviewRowActionButton
              isLoading={isActionPending}
              labelKey={actionKey}
              onClick={onAction}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default DashboardListRow
